// Which hrefs from written content (plans, tiers, tasks) are allowed to become
// links.
//
// It lives in its own plain module, apart from the renderer, for one reason:
// this is the only decision in the preview that puts a value from the content
// into an ATTRIBUTE. Everything else becomes a text child, which React escapes
// on its own. So this function is the whole attack surface, and a file with no
// JSX in it can be tested directly.
//
// An allowlist and not a blocklist. `javascript:` is the one everybody
// remembers; `data:`, `vbscript:` and `blob:` are the ones they forget, and a
// blocklist is only ever as complete as the last person who thought about it.
const SAFE_PROTOCOL = /^(https?:|mailto:)/i;

// Browsers ignore whitespace and control characters while reading the scheme,
// so "java\tscript:alert(1)" and a value with a leading newline are both live
// javascript URLs to them, while an anchored test on the raw string would see
// something that does not start with `javascript:` and wave it through.
//
// Written as a code-point comparison rather than a character class on purpose:
// a character-range class covering the control characters is one careless editor
// away from containing the control characters themselves.
function withoutIgnored(href) {
    let out = '';
    for (const character of href) {
        if (character.codePointAt(0) > 0x20) out += character;
    }
    return out;
}

export function isSafeHref(href) {
    if (typeof href !== 'string') return false;
    return SAFE_PROTOCOL.test(withoutIgnored(href));
}
